import AbnormalEnvironmentPage from '@/components/AbnormalEnvironmentPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/abnormal-environment')({
	component: () => <AbnormalEnvironmentPage />,
})
